// extracted by mini-css-extract-plugin
export default {"block":"ZRUb06 mz-cancel-buttons","cancelled":"i_5Bxh","cancel":"MA0abt mz-cancel-buttons__cancel","change":"JFwlSR mz-cancel-buttons__change"};